import type {
  TranslateNumberOptions,
  TranslateNumberValue,
} from "./translate-number.type";

export const translateNumber = (
  value: TranslateNumberValue,
  options: TranslateNumberOptions
) => {
  if (typeof value !== "number") return "";

  const { locale, ...formatOptions } = options ?? {};

  return new Intl.NumberFormat(locale, formatOptions).format(value);
};
